import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Slider from "../components/Slider"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class OurPromise extends Component {
  constructor(obj) {
    super(obj)

    this.sliderDOM = qs(".slider", this.el)

    this.slider = new Slider(this.sliderDOM)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  animate() {
    const title = qsa(".title .char-1", this.el)
    const description = qsa(".desktop-wrapper .line-0, .mobile-wrapper .line-0", this.el)
    const images = qsa(".inner", this.el)

    gsap.from(title, {
      y: "100%",
      stagger: 0.03,
      duration: 1.2,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.to(images, {
      width: "100%",
      height: "100%",
      stagger: 0.1,
      duration: 1.2,
      scrollTrigger: {
        trigger: images,
        start: "top bottom",
      },
    })

    gsap.from(description, {
      y: 100,
      autoAlpha: 0,
      stagger: 0.03,
      duration: 1.2,
      scrollTrigger: {
        trigger: description,
        start: "top bottom",
      },
    })
  }
}
